import { Dispatch, bindActionCreators } from 'redux';
import { useDispatch } from 'react-redux';

import { AuthActionTypes } from 'store/action-types';
import { User } from 'common/types';

type AuthDispatch = Dispatch<AuthActionTypes.Action>;

export const login = (user: User) => {
  return (dispatch: AuthDispatch) => {
    dispatch({
      type: AuthActionTypes.ActionType.LOGIN,
      payload: {
        user,
      },
    });
  };
};

export const logout = () => {
  return (dispatch: AuthDispatch) => {
    dispatch({
      type: AuthActionTypes.ActionType.LOGOUT,
    });
  };
};

export const actions = {
  login,
  logout,
};

export function useActions() {
  const dispatch = useDispatch<AuthDispatch>();
  return bindActionCreators(actions, dispatch);
}
